// src/layouts/DashboardLayout.jsx
import React, { useState, useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaHome } from "react-icons/fa";
import Navbar from "../components/Navbar";
import "./DashboardLayout.css";

const DashboardLayout = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const location = useLocation();

  // Close nav drawer on route change
  useEffect(() => {
    setNavbarOpen(false);
  }, [location.pathname]);

  // Lock body scroll when nav drawer is open
  useEffect(() => {
    if (navbarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [navbarOpen]);

  const toggleNavbarDrawer = () => {
    setNavbarOpen((prev) => !prev);
  };

  const closeNavbarDrawer = () => {
    setNavbarOpen(false);
  };

  return (
    <div className="dashboard-layout">
      {/* =======================
          Top Bar
         ======================= */}
      <header className="dashboard-topbar">
        <button
          className="hamburger-btn"
          onClick={toggleNavbarDrawer}
          aria-label="Toggle Main Navigation"
          aria-expanded={navbarOpen}
        >
          {navbarOpen ? <FaTimes /> : <FaBars />}
        </button>

        <h1 className="dashboard-title">Dashboard</h1>

        {/* Back to main site */}
        <Link to="/" className="dashboard-home-link">
          <FaHome />
          <span>Home</span>
        </Link>
      </header>

      {/* Main Navbar Drawer */}
      <div className={`dashboard-navbar-drawer ${navbarOpen ? "open" : ""}`}>
        <Navbar />
      </div>

      {/* =======================
          Overlay
         ======================= */}
      <div
        className={`dashboard-overlay ${
          navbarOpen ? "show" : ""
        }`}
        onClick={closeNavbarDrawer}
      />

      {/* =======================
          Main Content
         ======================= */}
      <main className="dashboard-main">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
